import { API_AWARD } from "globals/constants";
import { patch, remove, request, spUrl } from "utils";

const FUNDS = "funds";

export const funds = {
	/**
     * @param {string} id
     * @param {{}?} options
     */
	getAll: (awardId, options) =>
		request(spUrl(`${API_AWARD}/${awardId}/${FUNDS}`), options),

	/**
     * @param {{formId}} params
     * @param {{}} body
     * @param {{}?} options
     */
	link: (awardId, fundId, options) =>
		patch(spUrl(`${API_AWARD}/${awardId}/${FUNDS}/${fundId}`), {}, options),

	/**
     * @param {{formId}} params
     * @param {{}} body
     * @param {{}?} options
     */
	unlink: (awardId, fundId, options) =>
		remove(
			spUrl(`${API_AWARD}/${awardId}/${FUNDS}/${fundId}`),
			options,
		),
};
